import { toast, ToastOptions, ToastContainerProps } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';

// Base configuration for all toasts
const baseConfig: ToastOptions = {
  position: "top-right",
  // autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

// Container specific configuration
export const ToastContainerConfig: ToastContainerProps = {
  position: "top-right",
  // autoClose: 4000,
  newestOnTop: true,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  theme: "colored",
  limit: 3,
};

// Helper functions for consistent toast usage
export const notify = {
  success: (message: string) => toast.success(message, baseConfig),
  error: (message: string) => toast.error(message, { ...baseConfig, autoClose: 5000 }),
  warning: (message: string) => toast.warning(message, baseConfig),
  info: (message: string) => toast.info(message, baseConfig),
  confirm: (options: {
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }) => {
    confirmAlert({
      title: options.title,
      message: options.message,
      buttons: [
        {
          label: 'Yes, continue',
          onClick: options.onConfirm,
          className: 'confirm-yes'
        },
        {
          label: 'Cancel',
          onClick: options.onCancel || (() => {}),
          className: 'confirm-no'
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "confirm-overlay"
    });
  }
};